// Single source of truth for API paths - keeps route renames to one file instead of a grep-and-replace across pages.
export const API_AUTH = '/api/auth';
export const API_USERS = '/api/users';
export const API_BRANCHES = '/api/branches';
export const API_CERTIFICATES = '/api/certificates';
export const API_VERIFY = '/api/verify';
